import React from 'react';
import { useHistory } from 'react-router-dom';
import useBrandContext from 'Contexts/brand-context';
import add from 'date-fns/add';
import BaseBanner from 'Shared/components/banners/base-banner';
import InlineSvg from 'Shared/components/inline-svg';
import Button from 'Shared/components/button';
import { useTranslation } from 'Shared/util/custom-hooks';
import styles from './business-loans-banner.css';
import { Banner } from 'Shared/util/types';


const BusinessLoansBanner = () => {
  const history = useHistory();
  const { brandData } = useBrandContext();
  const t = useTranslation(x => x.businessLoansBanner);
  const handleButtonClick = () => history.push('/business-loans');

  const {
    phone,
  } = brandData;

  return (
    <BaseBanner
      id={Banner.BusinessLoans}
      closedUntil={add(new Date(), { months: 1 })}
      className={styles.customBanner}
      render={() => (
        <div className={styles.container}>
          <h2 className={styles.title}>{t.offerBusinessLoans}</h2>
          <div className={styles.contentContainer}>
            <Button
              buttonType="action-primary"
              text={t.applyNow}
              onClick={handleButtonClick}
            />
            <div className={styles.phone}>
              {t.orCall}  <a href={`tel:${phone}`}>{phone}</a>
            </div>
            <InlineSvg
              src="/pile-of-money.svg"
              className={styles.svgContainer}
            />
          </div>
        </div>
      )}
    />
  );
};

export default BusinessLoansBanner;
